# This code is based off of knockout-2.3.0.debug.js
# If we upgrade knockout, it is possible and/or likely that this will break


# Copied straight from debug file with no modifications
ko.utils.stringStartsWith = (string, startsWith) ->
    string = string or ''
    if startsWith.length > string.length
        return false
    return string.substring(0, startsWith.length) is startsWith

# Copied straight from debug file with no modifications
ko.utils.tagNameLower = (element) ->
    # For HTML elements, tagName will always be upper case; for XHTML elements, it'll be lower case.
    # Possible future optimization: If we know it's an element from an XHTML document (not HTML),
    # we don't need to do the .toLowerCase() as it will always be lower case anyway.
    return element and element.tagName and element.tagName.toLowerCase()


# Copied straight from debug file with no modifications
# Internal, private KO utility for updating model properties from within bindings
# property:            If the property being updated is (or might be) an observable, pass it here
#                      If it turns out to be a writable observable, it will be written to directly
# allBindingsAccessor: All bindings in the current execution context.
#                      This will be searched for a '_ko_property_writers' property in case you're writing to a non-observable
# key:                 The key identifying the property to be written. Example: for { hasFocus: myValue }, write to 'myValue' by specifying the key 'hasFocus'
# value:               The value to be written
# checkIfDifferent:    If true, and if the property being written is a writable observable, the value will only be written if
#                      it is !is existing value on that writable observable
ko.expressionRewriting.writeValueToProperty = (property, allBindingsAccessor, key, value, checkIfDifferent) ->
    if not property or not ko.isObservable(property)
        propWriters = allBindingsAccessor()['_ko_property_writers']
        if propWriters and propWriters[key]
            propWriters[key](value)
    else if ko.isWriteableObservable(property) and not checkIfDifferent or property.peek() isnt value
        property(value)

# Copied from debug file with 2 modifications
#################################################################
# KO modification here (writeValue -> writeValueAndTriggerChange)
#################################################################
ko.selectExtensions.writeValueAndTriggerChange = (element, value) ->
    switch ko.utils.tagNameLower(element)
        when 'option'
            switch typeof value
                when 'string'
                    ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, undefined)
                    if hasDomDataExpandoProperty in element
                    # IE <= 8 throws errors if you delete non-existent properties from a DOM node
                        delete element[hasDomDataExpandoProperty]
                    element.value = value
                else
                    # Store arbitrary object using DomData
                    ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, value)
                    element[hasDomDataExpandoProperty] = true

                    # Special treatment of numbers is just for backward compatibility.
                    # KO 1.2.1 wrote numerical values to element.value.
                    element.value = typeof value is 'number' ? value: ''
        when 'select'
            if value is ''
                value = undefined
            if value is null or value is undefined
                element.selectedIndex = -1
            for i in [element.options.length - 1..0]
                if ko.selectExtensions.readValue(element.options[i]) is value
                    element.selectedIndex = i
                    break
            # for drop-down select, ensure first is selected
            if not (element.size > 1) and element.selectedIndex is -1
                element.selectedIndex = 0
        else
            if value is null or value is undefined
                value = ''
            element.value = value
    #################################################################
    # KO modification here (added line)
    #################################################################
    $(element).trigger 'change'

# Copied from debug file with 2 modifications
#################################################################
# KO modification here (value -> valueTriggerChange)
#################################################################
ko.bindingHandlers['valueTriggerChange'] =
    init: (element, valueAccessor, allBindingsAccessor) ->
        # Always catch 'change' event; possibly other events too if asked
        eventsToCatch = ['change']
        requestedEventsToCatch = allBindingsAccessor()['valueUpdate']
        propertyChangedFired = false
        if requestedEventsToCatch
            if typeof requestedEventsToCatch is 'string' # Allow both individual event names, and arrays of event names
                requestedEventsToCatch = [requestedEventsToCatch]
            ko.utils.arrayPushAll(eventsToCatch, requestedEventsToCatch)
            eventsToCatch = ko.utils.arrayGetDistinctValues(eventsToCatch)

        valueUpdateHandler = () ->
            propertyChangedFired = false
            modelValue = valueAccessor()
            elementValue = ko.selectExtensions.readValue(element)
            ko.expressionRewriting.writeValueToProperty(modelValue, allBindingsAccessor, 'value', elementValue)

        ko.utils.arrayForEach(eventsToCatch, (eventName) ->
            # The syntax "after<eventname>" means "run the handler asynchronously after the event"
            # This is useful, for example, to catch "keydown" events after the browser has updated the control
            # (otherwise, ko.selectExtensions.readValue(this) will receive the control's value *before* the key event)
            handler = valueUpdateHandler
            if ko.utils.stringStartsWith(eventName, 'after')
                handler = () ->
                    setTimeout(valueUpdateHandler, 0)
                eventName = eventName.substring('after'.length)
            ko.utils.registerEventHandler(element, eventName, handler)
        )
    update: (element, valueAccessor) ->
        valueIsSelectOption = ko.utils.tagNameLower(element) is 'select'
        newValue = ko.utils.unwrapObservable(valueAccessor())
        elementValue = ko.selectExtensions.readValue(element)
        valueHasChanged = (newValue isnt elementValue)

        if valueHasChanged
            applyValueAction = () ->
                #################################################################
                # KO modification here (writeValue -> writeValueAndTriggerChange)
                #################################################################
                ko.selectExtensions.writeValueAndTriggerChange(element, newValue)
            applyValueAction()

        # If you try to set a model value that can't be represented in an already-populated dropdown,
        # reject that change,
        # because you're not allowed to have a model value that disagrees with a visible UI selection.
        if valueIsSelectOption and element.length > 0
            ensureDropdownSelectionIsConsistentWithModelValue(element, newValue, false)
